import React from 'react';
import GeneralSVG from "../generalSVG";
import LeftArrowIcon from "../icons/leftArrowIcon";

const PreviousWizardStepButton = (props) => {
    return (
        <div onClick={props._changeToPreviousStep}>
            <GeneralSVG
                SvgWrapper="quote-wizard-previous-step-label inlineBlock"
                Label={'Back to ' + props.previousStepName}
                Svg={<LeftArrowIcon/>}
            />
        </div>
    )
};

export default PreviousWizardStepButton